import React, { useEffect, useRef, useState } from "react";
import {  
  Form,
  Input,
  Modal,
  Select,
  Spin, 
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast"; 
import { save } from "../../../../features/save/saveSlice"; 

const { TextArea } = Input;

const AddNextOfKinModal = ({ open, handleCancel, handleFetchData, prodd,folderObj }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading,userData,thirdPartyData } = useSelector(
    (state) => state.dropdown
  );
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [data, setData] = useState({});

  const today = new Date();
  let dd = String(today.getDate()).padStart(2, 0);
  let mm = String(today.getMonth() + 1).padStart(2, 0);
  let yyyy = today.getFullYear() - 18;

  let minDate = `${yyyy}-${mm}-${dd}`;

  const [formData, setFormData] = useState(prodd);

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  function onMonthChange(value, formName) {
    setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if(!formData?.usrId){
      toast.error("Please select personnel")
      return
    }
   
    const res = await dispatch(
      save({
        ppId: folderObj?.ppId, 
        usrId: formData?.usrId, 
        userName:formData?.usrUsername,
        url: "usr/saveThirdPartyConnection.action",
      })
    );

    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({})
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };
 

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  //console.log("thirdPartyData",thirdPartyData)

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit NOk ${prodd?.nkFullname}`
            : "Select User From Billing"
        } 
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        > 
            <Form.Item
              className=""
              label={<span>Personnel From Billing</span>}
              rules={[
                {
                  required: true,
                  message: "Please select personnel from billing",
                },
              ]}
            >
              <Select
                name="usrId"
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  thirdPartyData?.length > 0 &&
                  thirdPartyData?.map((item) => ({
                    value: item?.usrId,
                    label: item?.usrUsername,
                  }))
                }
                onChange={(value) => {
                  handleSelectChange(value, "usrId");
                }}
                value={formData?.usrUsername}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => { 
                }}
                dropdownRender={(menu) => (
                  <>
                    {loading && (
                      <div
                        style={{
                          padding: "8px",
                          textAlign: "center",
                        }}
                      >
                        <Spin className="sms-spin" />
                      </div>
                    )}
                    {menu}
                  </>
                )}
              />
            </Form.Item>  
          
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddNextOfKinModal;
